/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index div to autogenerate all the elements and extensions
 * Used by "prepareDivs"
 */

import Div from './div/Div'
export * from './div/Div'
export default Div
